<template>
<div>
        <v-row>
              <v-col class="" cols="6" sm="8">
                <span 
                  class="font-weight-light grey--text text-capitalize" 
                  :class="{'body-1': $vuetify.breakpoint.xsOnly,'headline': $vuetify.breakpoint.smAndUp}"
                >Rightmove Analytics</span>
              </v-col>
        </v-row>
        <v-card class="mb-6">
            <v-card-title class="secondary white--text pa-3" id="card-title">
            <div class="">
                <v-icon class="mr-3" color="white" >mdi-home-variant</v-icon>
                <span class="">Rightmove Return on Investment</span>
            </div>
            </v-card-title>
            <v-simple-table>
            <template>
                <thead>
                    <tr>
                    <th class="text-center"></th>
                    <th class="text-center">Sales</th>
                    <th class="text-center">Lettings</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">Return on Investment</td>
                        <td class="text-center">{{calculateSalesRoI()}}%</td>
                        <td class="text-center">{{calculateLettingsRoI()}}%</td>
                    </tr>
                    <tr>
                        <td class="text-center">Total Fees</td>
                        <td class="text-center">{{feeSummary.DisplayTotalCompletedSalesFeesIncome}}</td>
                        <td class="text-center">{{feeSummary.DisplayTotalSignedLettingsFeesIncome}}</td>
                    </tr>
                </tbody>
            </template>
            </v-simple-table>
        </v-card>
        <v-card class="mb-6">
            <v-card-title class="secondary white--text pa-3" id="card-title">
            <div class="">
                <v-icon class="mr-3" color="white" >mdi-account-convert</v-icon>
                <span class="">Lead Utilisation</span>
            </div>
            </v-card-title>
            <v-simple-table>
            <template>
                <thead>
                    <tr>
                    <th class="text-center">Total Leads <v-icon @click="openTotalLeadsDialog()">mdi-information-outline</v-icon></th>
                    <th class="text-center">Leads Converted <v-icon @click="openConvertedLeadsDialog()">mdi-information-outline</v-icon></th>
                    <th class="text-center">Conversion (%)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">{{summary.TotalLeads}}</td>
                        <td class="text-center">{{summary.ConvertedLeads}}</td>
                        <td class="text-center">{{summary.ConversionRate}}%</td>
                    </tr>
                </tbody>
            </template>
            </v-simple-table>
        </v-card>
         <v-row>
          <v-col cols="12" sm="12" md="6" class="my-0">
            <v-card>
                <v-card-title class="secondary white--text pa-3" id="card-title">
                <div class="">
                    <v-icon class="mr-3" color="white" >mdi-currency-gbp</v-icon>
                    <span class="">Rightmove Lettings Perfomance</span>
                </div>
                </v-card-title>
                <v-simple-table>
                    <template>
                        <thead>
                            <tr>
                            <th class="text-center">Tenancies Signed  <v-icon @click="openTenanciesSignedDialog()">mdi-information-outline</v-icon></th>
                            <th class="text-center">Fees From Leads  <v-icon @click="openTenanciesFeesDialog()">mdi-information-outline</v-icon></th>
                            <th class="text-center">Monthly Cost  <v-icon @click="openTenanciesMonthlyCostsDialog()">mdi-information-outline</v-icon></th>
                            <th class="text-center">Return on Investment</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">{{feeSummary.TotalSignedLettings}}</td>
                                <td class="text-center">{{feeSummary.DisplayTotalSignedLettingsFeesIncome}}</td>
                                <td class="text-center">{{toCurrency(lettingsFee.amount)}}</td>
                                <td class="text-center">{{calculateLettingsRoI()}}%</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="my-0">
            <v-card>
                <v-card-title class="secondary white--text pa-3" id="card-title">
                <div class="">
                    <v-icon class="mr-3" color="white" >mdi-currency-gbp</v-icon>
                    <span class="">Rightmove Sales Perfomance</span>
                </div>
                </v-card-title>
                <v-simple-table>
                    <template>
                        <thead>
                            <tr>
                            <th class="text-center">Exchange/Sold Properties <v-icon @click="openSalesSoldDialog()">mdi-information-outline</v-icon></th>
                            <th class="text-center">Fees From Leads <v-icon @click="openSalesFeesDialog()">mdi-information-outline</v-icon></th>
                            <th class="text-center">Monthly Cost <v-icon @click="openSalesMonthlyCostsDialog()">mdi-information-outline</v-icon></th>
                            <th class="text-center">Return on Investment</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">{{feeSummary.TotalCompletedSales}}</td>
                                <td class="text-center">{{feeSummary.DisplayTotalCompletedSalesFeesIncome}}</td>
                                <td class="text-center">{{toCurrency(salesFee.amount)}}</td>
                                <td class="text-center">{{calculateSalesRoI()}}%</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
          </v-col>
         </v-row>
    <Popup
      :dialog="totalLeadsDialog"
      popupTitle="Total Leads"
      descriptionContent="The number of total leads is calculated from the number of leads imported from Rightmove for the given month."
      @closeDialog="closeTotalLeadsDialog"
    />
    <Popup
      :dialog="convertedLeadsDialog"
      popupTitle="Converted Leads"
      descriptionContent="The number of converted leads is calculated from the number of applicants created in OS from Rightmove leads."
      @closeDialog="closeConvertedLeadsDialog"
    />
        <Popup
      :dialog="tenanciesSignedDialog"
      popupTitle="Total Signed Tenancies"
      descriptionContent="The number of tenancies signed is calculated from the number of tenancies signed in OS by applicants that were converted from Rightmove Leads."
      @closeDialog="closeTenanciesSignedDialog"
    />
        <Popup
      :dialog="tenanciesFeesDialog"
      popupTitle="Fees From Leads"
      descriptionContent="The fees from leads are calculated from the fees applied to total signed tenancies."
      @closeDialog="closeTenanciesFeesDialog"
    />
        <Popup
      :dialog="tenanciesMonthlyCostsDialog"
      popupTitle="Monthly Fees"
      descriptionContent="Your monthly cost can be set for the month on the settings page."
      @closeDialog="closeTenanciesMonthlyCostsDialog"
    />
            <Popup
      :dialog="salesSoldDialog"
      popupTitle="Exchange/Sold Propertiess"
      descriptionContent="The number of sold/exchanged properties is calculated from the number of properties sold/exchanged in OS by applicants that were converted from Rightmove Leads."
      @closeDialog="closeSalesSoldDialog"
    />
        <Popup
      :dialog="salesFeesDialog"
      popupTitle="Fees From Leads"
      descriptionContent="*The fees from leads are calculated from the fees applied to total sold/exchanged properties."
      @closeDialog="closeSalesFeesDialog"
    />
        <Popup
      :dialog="salesMonthlyCostsDialog"
      popupTitle="Monthly Fees"
      descriptionContent="Your monthly cost can be set for the month on the settings page."
      @closeDialog="closeSalesMonthlyCostsDialog"
    />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Popup from './DescriptionPopupComponent';

export default {
  components : {
    Popup
  },
  data() {
    return {
totalLeadsDialog: false,
convertedLeadsDialog: false,
tenanciesSignedDialog: false,
tenanciesFeesDialog: false,
tenanciesMonthlyCostsDialog: false,
salesSoldDialog: false,
salesFeesDialog: false,
salesMonthlyCostsDialog: false
    }
  },
    methods:{
    openTotalLeadsDialog(){
      this.totalLeadsDialog = true;
    },
    closeTotalLeadsDialog() {
      this.totalLeadsDialog = false
    },
        openConvertedLeadsDialog(){
      this.convertedLeadsDialog = true;
    },
    closeConvertedLeadsDialog() {
      this.convertedLeadsDialog = false
    },
            openTenanciesSignedDialog(){
      this.tenanciesSignedDialog = true;
    },
    closeTenanciesSignedDialog() {
      this.tenanciesSignedDialog = false
    },
            openTenanciesFeesDialog(){
      this.tenanciesFeesDialog = true;
    },
    closeTenanciesFeesDialog() {
      this.tenanciesFeesDialog = false
    },
                openTenanciesMonthlyCostsDialog(){
      this.tenanciesMonthlyCostsDialog = true;
    },
    closeTenanciesMonthlyCostsDialog() {
      this.tenanciesMonthlyCostsDialog = false
    },
                    openSalesSoldDialog(){
      this.salesSoldDialog = true;
    },
    closeSalesSoldDialog() {
      this.salesSoldDialog = false
    },
                        openSalesFeesDialog(){
      this.salesFeesDialog = true;
    },
    closeSalesFeesDialog() {
      this.salesFeesDialog = false
    },
                            openSalesMonthlyCostsDialog(){
      this.salesMonthlyCostsDialog = true;
    },
    closeSalesMonthlyCostsDialog() {
      this.salesMonthlyCostsDialog = false
    },

        toCurrency: function (value) {
        if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat(this.$store.state.currencyData.LocaleCode, {
                style: 'currency',
                currency: this.$store.state.currencyData.CurrencyCode,
                minimumFractionDigits: this.$store.state.currencyData.CurrencyFractionDigits,
                maximumFractionDigits: this.$store.state.currencyData.CurrencyFractionDigits
            });
        return formatter.format(value);
        },
        calculateSalesRoI(){
            const income = this.feeSummary.TotalCompletedSalesFeesIncome;
            const fees = this.salesFee.amount;

            var result = ((income - fees) / fees);
            if(isNaN(result)){
                return 0;
            }
            else{
                return result;
            }
        },
        calculateLettingsRoI(){
            const income = this.feeSummary.TotalSignedLettingsFeesIncome;
            const fees = this.lettingsFee.amount;
            var result = ((income - fees) / fees);
            if(isNaN(result)){
                return 0;
            }
            else{
                return result;
            }
        }
    },
  computed:{
    ...mapState({
      summary: state => state.Rightmove.rightMoveLeadSummary,
      feeSummary: state => state.Rightmove.rightMoveFeeSummary,
      salesFee: state => state.Rightmove.rightMoveSalesFee,
      lettingsFee: state => state.Rightmove.rightMoveLettingsFee
    })

  },
    created() {
        this.$store.dispatch("Rightmove/getRightmoveLeadSummary");
        this.$store.dispatch("Rightmove/getRightmoveFeeSummary");
        this.$store.dispatch("Rightmove/getRightmoveSalesFee");
        this.$store.dispatch("Rightmove/getRightmoveLettingsFee");
    },
      watch:{
    '$store.state.reportMonth': function (){
        this.$store.dispatch("Rightmove/getRightmoveLeadSummary");
        this.$store.dispatch("Rightmove/getRightmoveFeeSummary");
        this.$store.dispatch("Rightmove/getRightmoveSalesFee");
        this.$store.dispatch("Rightmove/getRightmoveLettingsFee");
        },
    },
    filters:{

    }
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

.centered-input {
  text-align: center;
}
</style>